import * as React from "react";
import { EntryJSON } from "../models/entries";
import { queueSong } from "../state";
import { getEntryArtists } from "./SongMetadata";

interface QueueSongProps {
  entry: EntryJSON;
  dark?: boolean;
  variant?: "default" | "minimal";
}

export class QueueSong extends React.Component<QueueSongProps> {
  handleQueue(): void {
    if (!this.props.entry) {
      return;
    }
    if (!this.props.entry.uploaded_url) {
      return;
    }

    queueSong({
      name: this.props.entry.title,
      uploaded_url: this.props.entry.uploaded_url,
      entry_id: this.props.entry.id,
      entry_url: `/entry/${this.props.entry.id}`,
      artists: getEntryArtists(this.props.entry),
    });
  }

  render(): JSX.Element {
    if (!this.props.entry || !this.props.entry.uploaded_url) {
      return <span></span>;
    }

    const variant = this.props.variant || "default";
    const isMinimal = variant === "minimal";
    const colorClass = this.props.dark
      ? "border-white/20 text-white hover:bg-white/10 focus-visible:outline-white"
      : "border-slate-900/20 text-slate-900 hover:bg-slate-100 focus-visible:outline-slate-800";
    const minimalClass = this.props.dark
      ? "border-white/20 text-white/80 hover:bg-white/10 focus-visible:outline-white"
      : "border-slate-300 text-slate-600 hover:bg-slate-100 focus-visible:outline-slate-500";
    const buttonClass = isMinimal ? minimalClass : colorClass;
    const sizeClass = isMinimal
      ? "px-2 py-1 text-xs font-medium"
      : "px-2 py-1 text-xs uppercase tracking-wide";
    const label = isMinimal ? "queue" : "Queue";

    return (
      <button
        type="button"
        onClick={() => this.handleQueue()}
        className={`inline-flex items-center gap-1 rounded-full border bg-transparent transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${sizeClass} ${buttonClass}`}
      >
        <i className="fa fa-plus" aria-hidden="true"></i>
        {label}
      </button>
    );
  }
}
